function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Path_688",
  x: 0,
  y: 0,
  width: 94,
  height: 64,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 0, 0)",
  filter: "url(#Path_688)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_688-2",
  "data-name": "Path 688",
  d: "M945.466,543.188l-5.421,1.31a.974.974,0,0,1-.233.028.994.994,0,0,1-.231-1.96l2.183-.528-25.87-15.869.493,2.053a.991.991,0,1,1-1.927.466l-1.038-4.318a.976.976,0,0,1-.04-.168l-.229-.951,5.421-1.31a.994.994,0,0,1,.465,1.932l-2.216.536L942.734,540.3l-.5-2.086a.991.991,0,1,1,1.927-.466l1.052,4.379a.863.863,0,0,1,.024.1Zm43.459-18.972.228-.951-5.42-1.31a.994.994,0,0,0-.465,1.933l2.216.535-25.911,15.894.5-2.086a.991.991,0,1,0-1.927-.465l-1.052,4.377a.963.963,0,0,0-.024.1l-.23.957,5.421,1.311a1.028,1.028,0,0,0,.233.027.994.994,0,0,0,.231-1.96l-2.183-.528,25.87-15.869-.493,2.053a.994.994,0,0,0,.731,1.2.989.989,0,0,0,1.2-.733l1.038-4.318a1.076,1.076,0,0,0,.04-.168m-16.832-2.34a.974.974,0,0,1,.327.355l8.7-5.337L951.2,498.54l-8.576,5.26Zm-30.956-16.658a.981.981,0,0,1-.31-.315l-9.074,5.566,29.51,18.1a.968.968,0,0,1,.309.315l9.074-5.566Zm-10.83,6.694a.968.968,0,0,1-.328-.355l-8.7,5.337L951.2,535.248l8.575-5.26Z",
  transform: "translate(-904.15 -492.54)",
  fill: "#a7a8a9"
}));

function SvgTraySizeNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 64,
    viewBox: "0 0 94 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraySizeNew);
export default __webpack_public_path__ + "static/media/tray-size-new.601284d4.svg";
export { ForwardRef as ReactComponent };